export default {
  LOAD_SUBCOMPETENCY_LIST_START: 'LoadSubcompetencyListStart',
  LOAD_SUBCOMPETENCY_LIST_END: 'LoadSubcompetencyListEnd',
  TOGGLE_SUBCOMPETENCY_LIST_CONFIRM_DIALOG: 'ToggleSubcompetencyListConfirmDialog',
  FILTER_SUBCOMPETENCY_LIST: 'FilterSubcompetencyList',
  SORT_SUBCOMPETENCY_LIST: 'SortSubcompetencyList',
  SEARCH_SUBCOMPETENCY_LIST_FILTER_STUDY_PROGRAM_START: 'SearchSubcompetencyListFilterStudyProgramStart',
  SEARCH_SUBCOMPETENCY_LIST_FILTER_STUDY_PROGRAM_END: 'SearchSubcompetencyListFilterStudyProgramEnd'
};